var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import BrandAvatar from "@irati/ui/src/BrandAvatar";
export var DealAvatar = styled(BrandAvatar)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 80px;\n  height: 80px;\n  max-width: none;\n\n  ", "\n"], ["\n  width: 80px;\n  height: 80px;\n  max-width: none;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ",
        "\n  "])), theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: 140px;\n      height: 140px;\n    "], ["\n      width: 140px;\n      height: 140px;\n    "]))));
});
var templateObject_1, templateObject_2, templateObject_3;
